import React from 'react'

import inputTypes from './inputTypes'
import enhance from './enhance'
import { List, ListItem, Label } from './styles'

const InputListGeneral = ({
  ListWrapper = List,
  ListItemWrapper = ListItem,
  LabelWrapper = Label,
  InputComponent,
  type,
  input: { name: inputListName },
  options = [],
  updateCheckedItems,
  disabled,
  className,
  redactListItemsData = false,
  ...rest
}) => (
  <ListWrapper className={className}>
    {options.map(({ value, label, name: optionName, ...otherProps }, idx) => (
      <ListItemWrapper key={`${optionName}-${idx}`}>
        <InputComponent
          id={type === 'radio' ? `${inputListName}_${idx}` : optionName}
          name={type === 'radio' ? inputListName : optionName}
          label={label}
          value={value}
          disabled={disabled}
          onChange={value => updateCheckedItems(optionName, value)}
          data-testid={`input_${optionName}_${idx}`}
          {...otherProps}
          {...rest}
        />
        <LabelWrapper
          htmlFor={type === 'radio' ? `${inputListName}_${idx}` : optionName}
          data-heap-redact-text={redactListItemsData}
        >
          {label}
        </LabelWrapper>
      </ListItemWrapper>
    ))}
  </ListWrapper>
)

export default enhance(InputListGeneral)
